import React, { Component } from 'react';
import Radium from 'radium';

const ENTER = 13;

class TextField extends Component {

	onChange(evt) {
		this.props.onChange(evt.target.value);
	}

	onKeyDown(evt) {
		if (evt.keyCode === ENTER) {
			evt.preventDefault();
			this.props.onEnter();
		}
	}

	render() {
		return (
			<div style={this.localStyles().container}>
				<div style={this.props.style.global.label}>{this.props.label}</div>
				<input 
					value={this.props.value}
					type={this.props.type || "text"} 
					style={this.localStyles().input} 
					onKeyDown={(evt) => this.onKeyDown(evt)}
					placeholder={this.props.placeholder}
					onChange={(evt) => this.onChange(evt)}/>
				<div style={this.localStyles().gradientLine}></div>
			</div>
		)
	}

	localStyles() {
		return {
			container: {
				width: "100%",
				display: "flex",
				flexDirection: "column",
				marginTop: 20
			},
			input: {
				backgroundColor: "transparent",
				borderStyle: "none",
				width: "100%",
				outline: "none",
				fontSize: 18,
				fontWeight: "700",
				color: this.props.style.colors.black
			},
			gradientLine: {
				backgroundImage: this.props.style.gradients.line,
				width: "100%",
				height: 3,
				marginTop: 8
			}
		};
		
	};
}

export default Radium(TextField);


// WEBPACK FOOTER //
// ./src/components/TextField.js